import { getUserDisplayName } from '@utils/user-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ChannelLike = any;

/** Direct messages are labelled by the other participants, never by the
 * stored name snapshot (which was taken from the creator's point of view). */
export function channelLabel(
  channel: ChannelLike,
  viewerUserId: string | undefined
): string {
  if (!channel) return '';
  if (channel.dmChannel) {
    const others = (channel.members ?? [])
      .filter((member: ChannelLike) => member.userId !== viewerUserId)
      .map((member: ChannelLike) => getUserDisplayName(member.user ?? {}))
      .sort((a: string, b: string) => a.localeCompare(b));
    if (others.length) return others.join(', ');
  }
  return channel.name ?? '';
}

export type ChannelKind = 'public' | 'private' | 'dm' | 'group-dm';

export function channelKind(channel: ChannelLike): ChannelKind {
  if (!channel) return 'public';
  if (channel.dmChannel) {
    return (channel.members?.length ?? 0) > 2 ? 'group-dm' : 'dm';
  }
  return channel.isPrivate ? 'private' : 'public';
}
